import { IMAGE_ALT } from '../../seo/imageAltText';
import PictureImage from '../../components/Common/PictureImage';
import "./Tiktokhero.css";

export default function TikTokHero() {
  return (
    <section className="tt-hero">
      {/* Full-width background image */}
      <div className="tt-hero-bg">
        <PictureImage width={1920} height={1280}
          src="/Images/titkok-shop-image.webp"
          alt={IMAGE_ALT.tiktokLiveHero}
          className="tt-hero-bg-img"
          isHero />
        {/* White fade overlay from left */}
        <div className="tt-hero-fade-overlay" />
      </div>

      {/* ── Background blobs ── */}
      <div className="tt-bg-blob tt-bg-blob--1" />
      <div className="tt-bg-blob tt-bg-blob--2" />
      <div className="tt-bg-blob tt-bg-blob--3" />

      <div className="tt-container">
        {/* ══ LEFT CONTENT ══ */}
        <div className="tt-left">
          {/* Floating TikTok-style hearts / stars - decorative */}
          {/* <span className="tt-deco tt-deco--star1">⭐</span>
          <span className="tt-deco tt-deco--star2">✦</span>
          <span className="tt-deco tt-deco--heart">❤️</span> */}

          <h1 className="tt-title">
            TikTok fulfillment centers UK | TikTok Live Fulfilment
          </h1>

          <div className="home-hero-aeo-summary" style={{ background: 'rgba(255,255,255,0.9)', borderLeft: '4px solid #FE2C55', padding: '1rem 1.25rem', margin: '1.5rem 0', borderRadius: '4px', fontSize: '0.95rem', lineHeight: '1.5', color: '#111827', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
            <strong style={{ display: 'block', marginBottom: '0.25rem', color: '#FE2C55' }}>Executive Summary</strong>
            <strong>What is TikTok Live Fulfilment?</strong> It is the specialised process of rapidly picking, packing, and dispatching massive order spikes generated during viral TikTok Shop Live events. This service is designed for UK beauty, fashion, and lifestyle ecommerce brands who need to maintain strict Seller Level Agreements (SLAs) during flash sales. Based on our experience shipping tens of thousands of viral orders same-day, we integrate seamlessly with TikTok Shop and <a href="/shopify-fulfillment-services" style={{ color: '#FE2C55', textDecoration: 'underline' }}>Shopify</a> to ensure your <a href="/multi-channel-fulfillment-services" style={{ color: '#FE2C55', textDecoration: 'underline' }}>multi-channel</a> inventory stays synced, protecting your metrics from late-dispatch penalties.
          </div>

          <p className="tt-body">
            Reliable TikTok Shop fulfilment UK services designed for high-volume live selling events.
          </p>

          <ul className="tt-checklist">
            <li>
              <span className="tt-check">✓</span>
              Fast order processing for viral TikTok Shop products
            </li>
            <li>
              <span className="tt-check">✓</span>
              Real-time inventory synchronisation with TikTok Shop
            </li>
            <li>
              <span className="tt-check">✓</span>
              Expert handling of high-volume live selling orders
            </li>
          </ul>
        </div>

        {/* ══ RIGHT — Phone Mockup ══ */}
      
      </div>
    </section>
  );
}
